module.exports = __webpack_public_path__ + "static/media/identity-tbd-photo-1.cb2fbd98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-tbd-photo-1.jpg
// module id = 55
// module chunks = 0